import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/view/runProbe/uptime.view.runProbe.mutation.gql"
import type {
  UptimeViewRunProbeMutation,
  UptimeViewRunProbeMutationVariables,
} from "@/v2-backoffice-client/uptime/view/runProbe/__types__/uptime.view.runProbe.mutation"

type Options = MutationHookOptions<
  UptimeViewRunProbeMutation,
  UptimeViewRunProbeMutationVariables
>

export function useUptimeViewRunProbeMutation(options?: Options) {
  return useMutation<
    UptimeViewRunProbeMutation,
    UptimeViewRunProbeMutationVariables
  >(mutation, options)
}
